import React from 'react'
import Header from '../components/header'
import BreadCrumb from '../components/BreadCrumb'
import Footer from '../components/footer'
import DownloadArea from '../components/DownloadArea'
import FAQArea2 from '../components/FAQArea2'

function FaqPage() {
    const pageName = "FAQs"
  return (
    <div className='home-3'>
      <Header/>
      <BreadCrumb pageName={pageName}/>
      <main>
        <FAQArea2/>
        <DownloadArea/>
      </main>
      <Footer/>
    </div>
  )
}

export default FaqPage